import { useSelector, useDispatch } from 'react-redux'
import { useState } from 'react'
import { URLS } from '../../const/nav'
import { authFetch } from '../../services/authFetch'
import { setInformInfoInEvaluations } from '../../redux/evaluations'

export const useGetInformFromStudy = () => {
  const { user } = useSelector(state => state)
  const dispatch = useDispatch()
  const [inform, setInform] = useState(null)

  const getInformFromStudy = async (id) => {
    if (!id) {
      console.warn('getInformFromStudy: id is undefined or null')
      return null
    }

    const response = await authFetch(`${URLS.BACKEND_URL}/informes/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user.token}`
      }
    })
    const data = await response.json()
    setInform(data)
    dispatch(setInformInfoInEvaluations(data))
    return data
  }

  return { inform, getInformFromStudy }
}
